/**
 * How a pet's espécie and raça read on screen.
 *
 * Shared because four places show them — the Animais list, a unit page's pets strip, the detail
 * modal and the form — and they disagreed: the list showed a bare "siames" with no indication of
 * whether that was a cat or a dog, while the modal two clicks away showed "Gato".
 *
 * See petLabels.test.ts. The mobile apps keep the same mapping (`petSpeciesLabel` in Android's
 * PetsScreen.kt, `PetSpeciesLabel` on iOS) — a species offered in one and unlabelled in the other
 * is the drift those tests exist to catch.
 */

/**
 * Legacy pets were seeded with raw English enum values; newer ones already store the Portuguese
 * labels PetFormModal's select writes. Both have to read the same on a card, and a value this
 * build has never heard of passes through rather than vanishing — the operator typed it and can
 * recognise it.
 */
export const PET_SPECIES_LABELS: Record<string, string> = {
  dog: 'Cachorro',
  cat: 'Gato',
  bird: 'Ave',
  reptile: 'Réptil',
  rodent: 'Roedor',
  fish: 'Peixe',
  other: 'Outro',
};

export function petSpeciesLabel(species: string | null | undefined): string | undefined {
  const value = species?.trim();
  if (!value) return undefined;
  return PET_SPECIES_LABELS[value.toLowerCase()] ?? value;
}

/**
 * The raça exactly as the operator typed it, minus surrounding whitespace.
 *
 * Deliberately NOT title-cased or uppercased: "Shih Tzu" and "SRD" are both correct as entered,
 * and normalising would fight whichever convention the condomínio uses. Blank counts as absent so
 * a card never renders an empty chip.
 */
export function petBreedLabel(breed: string | null | undefined): string | undefined {
  const value = breed?.trim();
  return value ? value : undefined;
}
